import ArrowIcon from "@/common/images/icons/chevron-left.svg?react";
import { Link } from "react-router-dom";
import { IMenuItem, isLinkMenuItem } from "./types";
import { useCallback } from "react";
import "./MenuItem.scss";

export const MenuItem = (props: IMenuItem) => {
  const { title, icon: Icon, rightIcon: RightIcon, isActive, subMenu } = props;

  const className = `menuItem ${isActive ? "menuItemActive" : ""}`;

  const onClick = useCallback(() => {
    if (props.onClick) {
      props.onClick();
    }
  }, [props.onClick]);

  const content = (
    <>
      {Icon && <span className="menuItemIcon"><Icon /></span>}
      <span className="menuItemLabel">{title}</span>
      {subMenu && <span className={"menuItemArrow"}><ArrowIcon /></span>}
      {RightIcon && <span className="menuItemRightIcon"><RightIcon /></span>}
    </>
  );

  if (isLinkMenuItem(props)) {
    if (props.external) {
      return (
        <a
          className={className}
          href={props.link}
          onClick={onClick}
          target={props.target}
          rel={props.rel ?? "noopener noreferrer"}
        >
          {content}
        </a>
      );
    }

    return (
      <Link className={className} to={props.link} onClick={onClick}>
        {content}
      </Link>
    );
  }

  return (
    <button type="button" className={className} onClick={onClick}>
      {content}
    </button>
  );
};
